export const SPLASH_DOWNLOAD_LATER_KEY = "scabSplashDownloadLater";

export const isAndroidDevice = () => {
  const ua = navigator.userAgent || "";
  const isAndroid = /Android/i.test(ua);
  const isIos = /iPhone|iPad|iPod/i.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  return isAndroid && !isIos;
};
